import React from 'react';
import { Profile, SatCoreRegister } from 'sat-core';

const ProfileOverride = (props) => <Profile {...props} changePasswordModal={false} fullScreenModal={false} />;

SatCoreRegister('Profile', ProfileOverride);
